import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Notify,
  Spacer,
  Text,
} from "@flexisaf/flexibull2";

import { useState } from "react";
import Theme from "../../../theme";
import { FileUploader } from "../../fileUploader";
import { StepList } from "./styles";
import BulkUploadTemplate from "../../../assets/templates/bulkQuestionTemplate.xlsx";
import useQuestionEditor from "../../../hooks/questions/useQuestionEditor";

const BulkQuestionUpload = ({ open, onClose, paperId, refetch }) => {
  const { uploadBulkQuestions, isEditing: uploadingQuestions } =
    useQuestionEditor();
  const [File, setFile] = useState(null);

  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", File);

    const payload = {
      data: { formData, paperId },
      callback: () => {
        reset();
        refetch();
      },
    };
    uploadBulkQuestions(payload);
  };

  const reset = () => {
    setFile(null);
    onClose();
  };
  const handleFile = (e) => {
    e.stopPropagation();

    const file = e.target.files[0];
    const uploadLimit = file.size / 1024 / 1024 < 2.5;

    if (!uploadLimit) {
      Notify("File must not exceed 2.5MB", { status: "error" });
      return;
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      Notify("Invalid file, please select a pdf file", { status: "error" });
      setFile(null);
    } else {
      setFile(file);
    }
  };

  return (
    <Modal onClose={() => reset()} center={false} open={open}>
      <ModalBody>
        <Box pad="30px">
          <Box>
            <Text size={Theme.H6}>Bulk Upload Question</Text>
          </Box>
          <Box pad="30px 0 0 0">
            <Text block bold size="14px">
              Upload XLSX File
            </Text>
            <Text block size="11px" style={{ margin: "10px 0" }}>
              {" "}
              Select your XLSX file from your computer to upload it using that
              uploader provided for you below{" "}
            </Text>
            <Spacer />
            <Box style={{ borderBottom: "1px solid #d1d1d1" }} />

            <Box pad="25px 0">
              <FileUploader
                onChange={(e) => handleFile(e)}
                label="Select your Excel file"
                size="Maximum size 2.5mb"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                name="bulkquestion"
              />
              {File ? <p>File: {File.name}</p> : null}
              <Button
                progress={uploadingQuestions}
                disabled={!File}
                onClick={() => handleUpload()}
              >
                {" "}
                Upload Excel File{" "}
              </Button>
            </Box>
          </Box>
          <Box pad="30px 0 0 0">
            <Text block bold size="14px">
              Download XLSX file
            </Text>
            <Text block size="11px" style={{ margin: "10px 0" }}>
              {" "}
              Follow the steps below to download and use the excel file
              effectively{" "}
            </Text>
            <Spacer />
            <Box style={{ borderBottom: "1px solid #d1d1d1" }} />

            <Box pad="25px 0">
              <StepList>
                <span className="step"> Step 1: </span>
                <p>
                  Click the button below to download the bulk question upload
                  excel file
                </p>
                <br />
                <a
                  href={BulkUploadTemplate}
                  target="_blank"
                  rel="noreferrer"
                  download="Bulk Questions Template"
                  style={{ margin: "auto" }}
                >
                  <Button>Download XLSX Template</Button>
                </a>
              </StepList>
              <StepList>
                <span className="step"> Step 2: </span>
                <p>Open the file on your computer</p>
              </StepList>

              <StepList>
                <span className="step"> Step 3: </span>
                <p>
                  Fill all sections provided with the necessary format, then
                  save
                </p>
              </StepList>
              <StepList>
                <span className="step"> Step 4: </span>
                <p>
                  Click on the 'Browse File' button to select the filled
                  template saved on your computer
                </p>
              </StepList>

              <StepList>
                <span className="step"> Step 5: </span>
                <p>Click on the 'Upload Excel File' button to upload</p>
              </StepList>
            </Box>
          </Box>
        </Box>
        <ModalFooter>
          <Box pad="20px" align="right">
            <Button
              pale
              color="rgba(0,0,0,0)"
              onClick={() => reset()}
              fontColor={Theme.PrimaryGrey}
            >
              Cancel
            </Button>
          </Box>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
};

export default BulkQuestionUpload;
